export default __webpack_public_path__ + "static/media/menu_toggle.408ea3f3.svg";